import { Heading, Stack } from "@chakra-ui/react";
import React from "react";
import { DataUtils, ImageSize, PostData, SiteData } from "../clients/data-service";
import ReactMarkdown from "react-markdown";
import { Prose } from '@nikolovlazar/chakra-ui-prose'

export default class PostDisplay extends React.Component<{ post: PostData, embeded?: boolean, siteData: SiteData }> {


        render() {
            const data = this.props.siteData;
            const transformImageUri = (uri: string) : string => {
                if (uri.startsWith("/team-photo/")) {
                    const teamId = uri.substring(12);
                    const team = data.Teams.find(t => t.id == teamId);
                    if (team) {
                        return DataUtils.BestTeamImage(data, team, ImageSize.Medium) ?? uri;
                    }
                }

                return uri
            }

            return (<>
                <Stack w={'100%'}>
                    <Heading as='h1' size='2xl' textAlign='center' mt={{ base: 6, md: 12 }} mb={this.props.embeded ? { base: 4, md: 6 } : { base: 4, md: 12 }}>{this.props.post.title}</Heading>
                    <Prose>
                        <ReactMarkdown children={this.props.post.body} transformImageUri={transformImageUri} skipHtml />
                    </Prose>
                </Stack>
            </>);
        }
    }